export const pathes = {
  DEFAULT: '/',
  BASE_PATH: '/',
  ON_BOARDING: '/on-boarding',
  LOGIN_PHONE_NUMBER: '/login-phone-number',
  LOGIN_USERNAME: '/login-username',
  LOGIN_LEGAL_USER: '/login-legal-user',
  SIGNUP_LEGAL_USER: '/signup-legal-user',
  SIGNUP: '/signup',
  LOGIN_OTP: '/login-otp',
  SIGNUP_FORM: '/signup-form',
  CHANGE_NUMBER: '/change-number',
  CHANGE_NUMBER_OTP: '/change-number-otp',
  HOME: '/home',
  PROFILE: '/profile',
  GROUP: '/group',
  MY_GROUPS: '/my-groups',
  CHOOSE_GROUP: '/choose-group',
  CREATE_GROUP: '/create-group',
  WALLET: '/wallet',
  WALLET_BARCODE: '/wallet/:id/:destId',
  SETTING: '/setting',
  CHANGE_BACKGROUND: '/change-background',
  MY_GIFTS: '/my-gifts',
  QR_PAYMENT: '/qr-payment',
  PAYMENT_CODE: '/payment-code',
  PAYMENT: '/payment',
  SUCCESS_PAYMENT: '/success-payment',
  TRANSACTION_RECEIPT: '/transaction-receipt',
  FAQ: '/faq',
  ABOUT_SHAHRZAD: '/about-shahrzad',
  CASH_WITH_DRAWAL: '/cash-with-drawal',
  USER_LEVELS: '/user-levels',
  PRIVACY: '/privacy',
  CINEMA: '/festival-tickets',
  SUPPORT_TICKET: '/support-ticket',
  USER_MESSAGE: '/user-message/:id',
  V_CARD: '/v-card',
  INVITE_FRIENDS: '/invite-friends',
  SHAHRZAD_CODE: '/shahrzad-code',
  FESTIVAL: '/festival',
  SHOP_PAYMENT: '/shop-payment/:id',
  CENTERS_PAYMENT: '/centers-payment/:barcode',
  RECEIVE_PAYMENT: '/receive-payment/:terminalId',

  // ERROR
  ERROR_502: '/error/502-bad-gateway',
  ERROR_503: '/error/503-service-unavailable',
  ERROR_504: '/error/504-gateway-timeout',
}
